var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0856 7.21405C11.0856 6.88019 10.8147 6.60962 10.4808 6.60962H0.897402C0.563543 6.60962 0.292969 6.88019 0.292969 7.21405V7.59831H1.03875V11.6035C1.03875 12.0992 1.44045 12.5001 1.93498 12.5001H9.46179C9.95747 12.5001 10.358 12.098 10.358 11.6035V7.59793H11.0856V7.21405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.97342 4.96902H8.5176C8.91702 4.96902 9.2414 4.64084 9.2414 4.2418V1.08359C9.2414 0.761479 8.97727 0.5 8.6544 0.5C8.33153 0.5 8.06664 0.761479 8.06664 1.08359V3.79464H7.5524C7.41105 3.70141 7.24279 3.64571 7.0609 3.64571H4.32635C3.82045 3.64571 3.40625 4.06332 3.40625 4.56922V6.01304H7.97342V4.96902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.6928 3.12413C6.41737 3.12413 7.00475 2.53675 7.00475 1.81219C7.00475 1.08762 6.41737 0.500244 5.6928 0.500244C4.96824 0.500244 4.38086 1.08762 4.38086 1.81219C4.38086 2.53675 4.96824 3.12413 5.6928 3.12413Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolStudentIcon);
export default __webpack_public_path__ + "static/media/schoolStudentIcon.58c8be2598b74974de66fbf877593a78.svg";
export { ForwardRef as ReactComponent };